import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { of, switchMap } from 'rxjs';
import { UserSharedService } from '../core/users/user.service';

export const SuperAuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);

    // Check the authentication status
    return inject(UserSharedService)
        .check()
        .pipe(
            switchMap((authenticate) => {
                // If the user is not authenticated...
                if (authenticate) {
                    // Redirect to the sign-in page with a redirectUrl param
                    const usercCode=    localStorage.getItem('userCode');
                    const userRole=    localStorage.getItem('userRole');    
                    if(usercCode && userRole){
                        if(userRole === 'super-admin'){
                            return of(true);
                        }else{
                            router.navigate(['/login']);
                            return of(false);
                        }   
                    }
                }

                // Allow the access
                const redirectURL =
                        state.url === '/login'
                            ? ''
                            : `redirectURL=${state.url}`;
                    const urlTree = router.parseUrl(`sign-in?${redirectURL}`);
                console.log('urlTree', urlTree);
                console.log('state.url', state.url);
                    return of(urlTree);
            })
        );
};


export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);

    // Check the authentication status
    return inject(UserSharedService)
        .check()
        .pipe(
            switchMap((authenticate) => {
                // If the user is not authenticated...
                if (authenticate) {
                    // Redirect to the sign-in page with a redirectUrl param
                    const usercCode =    localStorage.getItem('userCode');
                    const userRole =    localStorage.getItem('userRole');    
                    if(usercCode && userRole){
                        if(userRole === 'ADMIN' || userRole === 'STAFF'){
                            return of(true);
                        }else{
                            router.navigate(['/login']);
                            return of(false);
                        }   
                    }
                }

                // Allow the access
                const redirectURL =
                        state.url === '/login'
                            ? ''
                            : `redirectURL=${state.url}`;
                    const urlTree = router.parseUrl(`sign-in?${redirectURL}`);

                    return of(urlTree);
            })
        );
};
